import sigliveServiceV2 from 'Service/sigliveServiceV2';

const postRoleAvailability = async ({ payload }) => {
  const { data } = await sigliveServiceV2({ method: 'POST', url: `/access/role/availability`, data: payload });

  return data?.data;
};

export default postRoleAvailability;
